/* TODO: t() */
import React from 'react';

const TemplateHorizontalSquare = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="52" height="26" viewBox="0 0 52 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-250 -315) translate(250 315)">
        <rect
          width="51"
          height="25"
          x=".5"
          y=".5"
          fill="#FFF"
          stroke="#0A2841"
          strokeOpacity=".2"
          rx="2"
        />
        <rect width="18" height="18" x="4" y="4" fill="#CED4D9" rx="1" />
        <rect width="12" height="4" x="26" y="8" fill="#CED4D9" rx="1" />
        <rect width="18" height="4" x="26" y="14" fill="#CED4D9" rx="1" />
      </g>
    </g>
  </svg>
);

export default TemplateHorizontalSquare;
